<template>
  <v-dialog
      :value="value"
      max-width="500"
      @click:outside="close"
  >
    <v-card>
      <v-card-title>
        ２次承認依頼
      </v-card-title>
      <v-card-text>
        <v-select
            dense
            hide-details="auto"
            outlined
            label="承認者*"
            :items="areaMembers"
            v-model="confirmer"
            class="mb-4"
            :rules="[(v) => !!v || '承認者を選択してください。']"
            :item-value="item => item.email"
            no-data-text="該当データがありません。"
        >
          <template v-slot:selection="{item}">
            {{item.name}} {{ item.name ? '|' : null }} {{item.email}}
          </template>
          <template v-slot:item="{item}">
            {{item.name}} {{ item.name ? '|' : null }} {{item.email}}
          </template>
        </v-select>
        <v-textarea
            v-model="requestComment"
            label="コメント"
            outlined
        ></v-textarea>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn @click="close" depressed>キャンセル</v-btn>
        <v-btn @click="sendRequest" color="primary" :disabled="!confirmer">依頼</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "RequestLeaderConfirmationDialog",
  props: ['value', 'folderId', 'report'],
  data(){
    return {
      requestComment: '',
      areaMembers: [],
      areaLeader: '',
      confirmer: ''
    }
  },

  methods: {
    close(){
      this.$emit('input');
    },
    sendRequest(){
      store.showLoadingOverlay(true);
      this.axios
          .post(`/api/report/request-confirmation/${this.folderId}`,
              {
                confirmer: this.confirmer,
                comment: this.requestComment.trim(),
                type: 'area_confirm',
                updated_at: this.report.updated_at
              })
          .then((response) => {
            store.showSuccessDialog('相手に確認を依頼しました。');
            this.close();
            this.$emit('requested', response.data);
          })
          .catch((error) => {
            store.showErrorDialog(error.response.data.message);
            if (error.response.status === 403){
              this.$emit('updateOutdatedReport', error.response.data.report, error.response.data.report_pdf_pages);
            }
            this.$emit('input');
          })
          .then(() => {
            store.showLoadingOverlay(false);
          });
    }
  },

  created() {
    this.axios
        .get('/api/area/' + this.folderId)
        .then((response) => {
          this.areaMembers = Object.values(response.data.members);
          this.areaLeader = response.data.area.leader;
          this.confirmer = this.areaMembers.find(i => i === this.areaLeader);
        });
  }
}
</script>

<style scoped>

</style>
